import React from 'react';
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as partnerAction from '../action/partnerAction';
//Material-ui
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import Button from '@material-ui/core/Button';


class Comp extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			disabled: false,
			animation: false,
		}
	}

	_click() {
		if (this.state.disabled) {
			return false;
		}
		else {
			this.setState({disabled:true});
			if (this.props.goodSended === 0) {
				this.setState({animation:true});
			}
			else {
				this.setState({animation:false});
			}
			this.props.click();
			setTimeout(function(){
				this.setState({disabled:false});
			}.bind(this), 500);
		}
	}

	render() {
		return (
			<span>
	      <Button
	        variant="outlined"
	        onClick={ () => this._click() }
					style={{
						color: (this.props.goodSended > 0) ? "#FFF" : "#666",
						background: (this.props.goodSended > 0) ? "#FFBC57" : "#FFF",
						border: (this.props.goodSended > 0) ? "#FF9900 solid 1px" : "#AAA solid 1px",
					}}
	      >
	          <ThumbUpIcon
							className={(this.state.animation) ? 'postGoodIconAnimation' : ''}
						 	style={{display:'inline-flex',verticalAlign:'middle'}}
						/>
						&nbsp;
						いいね&nbsp;
						{
							(this.props.goodCountNondisplay > 0) ? (
								<span>「いいねの数は秘密」</span>
							) : (
								<span>{this.props.goodCount}</span>
							)
						}
	      </Button>
			</span>
		)
	}
}

const mapStateToProps = (state) => {
	return {
    my: state.my,
		communityPost: state.communityPost,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...partnerAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
